export enum AppCacheKeys {
  City = 'App_Cache_City',
  CitySlug = 'App_Cache_CitySlug',
  UserProfile = 'App_Cache_UserProfile',
  MissionAddressMode = 'App_Cache_MissionAddressMode',
}
